import React from 'react';
import { Button } from '../ui/Button';
import { Card } from '../ui/Card';
import { ShieldCheck, Download } from 'lucide-react';
import { trackAddToCart } from '../../utils/metaPixel';
export function Pricing() {
  const handleBuyClick = () => {
    // Track AddToCart event before redirecting
    trackAddToCart();
    // Open Shopify cart in new tab
    window.open('https://prodigitalideas.com/cart/51116124078378:1', '_blank');
  };
  return <section id="pricing" className="py-12 md:py-24 px-4 bg-slate-950 relative" data-id="element-59">
      <div className="max-w-3xl mx-auto text-center space-y-8 md:space-y-12" data-id="element-60">
        <div className="space-y-4 md:space-y-6" data-id="element-61">
          <h2 className="text-3xl md:text-5xl font-serif text-amber-50" data-id="element-62">
            Recupera el control de tus noches
          </h2>
          <p className="text-slate-400 text-lg" data-id="element-63">
            Si te despiertas esta noche a las 3am, esto ya puede estar en tu
            teléfono.
          </p>
        </div>

        <Card variant="highlight" className="relative overflow-hidden p-8 md:p-12" data-id="element-64">
          <div className="absolute top-0 right-0 bg-amber-500 text-slate-900 text-xs font-bold px-3 py-1 rounded-bl-lg" data-id="element-65">
            ACCESO INMEDIATO
          </div>

          <div className="flex flex-col md:flex-row items-center justify-between gap-8" data-id="element-66">
            <div className="text-left space-y-2" data-id="element-67">
              <h3 className="text-2xl font-bold text-slate-100" data-id="element-68">
                3AM Otra Vez
              </h3>
              <p className="text-slate-400" data-id="element-69">
                Protocolo de Sueño en Perimenopausia
              </p>
              <div className="flex gap-2 text-sm text-amber-400/80 mt-2" data-id="element-70">
                <span className="bg-amber-950/40 px-2 py-0.5 rounded border border-amber-900/50" data-id="element-71">
                  Ebook con Guía
                </span>
                <span className="bg-amber-950/40 px-2 py-0.5 rounded border border-amber-900/50" data-id="element-72">
                  Workbook
                </span>
                <span className="bg-amber-950/40 px-2 py-0.5 rounded border border-amber-900/50" data-id="element-73">
                  Tarjeta SOS
                </span>
              </div>
            </div>

            <div className="text-right" data-id="element-74">
              <div className="flex items-baseline justify-end gap-1" data-id="element-75">
                <span className="text-lg text-slate-500 line-through" data-id="element-76">$29</span>
                <span className="text-5xl font-serif font-bold text-amber-400" data-id="element-77">
                  $6.39
                </span>
              </div>
              <p className="text-slate-500 text-sm mt-1" data-id="element-78">
                Pago único. Tuyo para siempre.
              </p>
            </div>
          </div>

          <div className="mt-8 pt-8 border-t border-slate-700/50" data-id="element-79">
            <Button size="lg" fullWidth className="text-lg font-semibold py-6 shadow-amber-500/20 shadow-xl" onClick={handleBuyClick} data-id="element-80">
              <Download className="w-5 h-5 mr-2" data-id="element-81" />
              Descargar Protocolo Ahora
            </Button>

            <div className="mt-4 flex items-center justify-center gap-2 text-slate-500 text-sm" data-id="element-82">
              <ShieldCheck className="w-4 h-4" data-id="element-83" />
              <span data-id="element-84">Pago seguro vía PayPal • Garantía de satisfacción</span>
            </div>
          </div>
        </Card>

        <div className="space-y-6 max-w-2xl mx-auto pt-8" data-id="element-85">
          <h4 className="text-slate-200 font-serif text-xl" data-id="element-86">
            ¿Para quién es esto?
          </h4>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-left" data-id="element-87">
            <div className="bg-slate-900 p-4 rounded-lg border border-slate-800" data-id="element-88">
              <span className="text-green-400 font-bold block mb-2" data-id="element-89">
                SÍ es para ti si:
              </span>
              <ul className="text-sm text-slate-400 space-y-2" data-id="element-90">
                <li data-id="element-91">• Te despiertas 3+ noches/semana</li>
                <li data-id="element-92">• Sientes calor, ansiedad o mente acelerada</li>
                <li data-id="element-93">• Estás cansada de improvisar</li>
              </ul>
            </div>
            <div className="bg-slate-900 p-4 rounded-lg border border-slate-800" data-id="element-94">
              <span className="text-red-400 font-bold block mb-2" data-id="element-95">
                NO es para ti si:
              </span>
              <ul className="text-sm text-slate-400 space-y-2" data-id="element-96">
                <li data-id="element-97">• Buscas una "cura hormonal" médica</li>
                <li data-id="element-98">• Quieres reemplazar atención profesional</li>
                <li data-id="element-99">• No estás dispuesta a soltar el celular</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>;
}